import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  Save,
  Trash2,
  Edit3,
  Plus,
  Book,
  ShieldAlert,
  ShieldCheck,
  Loader2,
  CheckCircle,
  XCircle,
  AlertTriangle,
} from "lucide-react";

export default function KelolaMapel() {
  const [mapelList, setMapelList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  // STATE FORM
  const [formData, setFormData] = useState({ nama_mapel: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  // STATE NOTIFIKASI (TOAST)
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "success",
  });

  // STATE MODAL KONFIRMASI HAPUS (BARU)
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: null,
    nama: "",
  });

  useEffect(() => {
    verifikasiAdmin();
    fetchMapel();
  }, []);

  // --- FUNGSI HELPER NOTIFIKASI ---
  const showToast = (message, type = "success") => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification((prev) => ({ ...prev, show: false }));
    }, 3000);
  };

  // --- 1. VERIFIKASI ADMIN ---
  async function verifikasiAdmin() {
    const localUser = JSON.parse(localStorage.getItem("ruangKelasUser"));
    if (
      localUser &&
      ["admin", "administrator", "kepala"].includes(
        localUser.role.toLowerCase()
      )
    ) {
      setIsAdmin(true);
      return;
    }
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (session) {
      let { data: akun } = await supabase
        .from("akun")
        .select("role")
        .eq("id", session.user.id)
        .single();
      if (!akun) {
        const { data: akunByEmail } = await supabase
          .from("akun")
          .select("role")
          .eq("username", session.user.email)
          .single();
        akun = akunByEmail;
      }
      if (
        akun &&
        ["admin", "administrator", "kepala"].includes(akun.role.toLowerCase())
      ) {
        setIsAdmin(true);
      }
    }
  }

  // --- 2. AMBIL DATA ---
  async function fetchMapel() {
    setLoading(true);
    const { data, error } = await supabase
      .from("mata_pelajaran")
      .select("*")
      .order("nama_mapel", { ascending: true });
    if (error) console.error(error);
    setMapelList(data || []);
    setLoading(false);
  }

  // --- 3. SIMPAN DATA ---
  async function handleSimpan(e) {
    e.preventDefault();
    if (!formData.nama_mapel) {
      showToast("Nama Mata Pelajaran tidak boleh kosong!", "error");
      return;
    }

    try {
      if (isEditing) {
        const { error } = await supabase
          .from("mata_pelajaran")
          .update({ nama_mapel: formData.nama_mapel })
          .eq("id", editId);
        if (error) throw error;
        showToast("Data berhasil diperbarui!", "success");
      } else {
        const { error } = await supabase
          .from("mata_pelajaran")
          .insert([{ nama_mapel: formData.nama_mapel }]);
        if (error) throw error;
        showToast("Mapel baru berhasil disimpan!", "success");
      }

      setFormData({ nama_mapel: "" });
      setIsEditing(false);
      fetchMapel();
    } catch (error) {
      showToast("Gagal menyimpan: " + error.message, "error");
    }
  }

  // --- 4. HAPUS DATA (DENGAN MODAL BARU) ---

  // Langkah A: Klik tombol tong sampah -> Buka Modal
  function clickHapus(item) {
    setDeleteModal({
      show: true,
      id: item.id,
      nama: item.nama_mapel,
    });
  }

  // Langkah B: Klik "Ya, Hapus" di dalam Modal -> Eksekusi Hapus
  async function confirmHapus() {
    const id = deleteModal.id;
    // Tutup modal dulu agar responsif
    setDeleteModal({ show: false, id: null, nama: "" });

    const { error } = await supabase
      .from("mata_pelajaran")
      .delete()
      .eq("id", id);

    if (error) {
      showToast("Gagal hapus. Data sedang digunakan.", "error");
    } else {
      showToast("Data berhasil dihapus.", "success");
      fetchMapel();
    }
  }

  // Langkah C: Klik "Batal" -> Tutup Modal
  function cancelHapus() {
    setDeleteModal({ show: false, id: null, nama: "" });
  }

  function handleEdit(item) {
    setFormData({ nama_mapel: item.nama_mapel });
    setIsEditing(true);
    setEditId(item.id);
  }

  // --- TAMPILAN LOADING ---
  if (loading)
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: "#f8fafc",
        }}
      >
        <Loader2 className="animate-spin" size={40} color="#2563eb" />
        <p
          style={{ marginTop: 15, color: "#64748b", fontFamily: "sans-serif" }}
        >
          Memuat Data...
        </p>
      </div>
    );

  // --- TAMPILAN AKSES DITOLAK ---
  if (!isAdmin) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f1f5f9",
          fontFamily: "'Inter', sans-serif",
          padding: "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: "40px 30px",
            borderRadius: "24px",
            boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
            maxWidth: "400px",
            width: "100%",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "80px",
              height: "80px",
              background: "#fee2e2",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px auto",
            }}
          >
            <ShieldAlert size={40} color="#dc2626" />
          </div>
          <h2
            style={{
              margin: "0 0 12px 0",
              color: "#1e293b",
              fontSize: "24px",
              fontWeight: "800",
            }}
          >
            Akses Dibatasi
          </h2>
          <p
            style={{
              margin: "0 0 30px 0",
              color: "#64748b",
              lineHeight: "1.6",
              fontSize: "15px",
            }}
          >
            Halaman ini dilindungi dan hanya dapat diakses oleh Administrator.
          </p>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              padding: "14px 0",
              background: "#2563eb",
              color: "white",
              borderRadius: "12px",
              textDecoration: "none",
              fontWeight: "700",
            }}
          >
            <ArrowLeft size={18} style={{ marginRight: 8 }} /> Kembali ke
            Dashboard
          </Link>
        </div>
      </div>
    );
  }

  // --- STYLE MODAL OVERLAY ---
  const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(15, 23, 42, 0.6)", // Gelap transparan
    backdropFilter: "blur(4px)", // Efek blur di background
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10000,
    opacity: deleteModal.show ? 1 : 0,
    visibility: deleteModal.show ? "visible" : "hidden",
    transition: "all 0.2s ease-in-out",
  };

  const modalContentStyle = {
    background: "white",
    padding: "30px",
    borderRadius: "20px",
    width: "90%",
    maxWidth: "350px",
    textAlign: "center",
    transform: deleteModal.show ? "scale(1)" : "scale(0.95)",
    transition: "all 0.2s ease-in-out",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  };

  const toastStyle = {
    position: "fixed",
    left: "50%",
    transform: "translateX(-50%)",
    top: notification.show ? "30px" : "-80px",
    opacity: notification.show ? 1 : 0,
    background: "white",
    padding: "12px 24px",
    borderRadius: "50px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    zIndex: 9999,
    minWidth: "320px",
    justifyContent: "center",
    border:
      notification.type === "success"
        ? "1px solid #dcfce7"
        : "1px solid #fee2e2",
    transition: "all 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55)",
  };

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "sans-serif",
        background: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      {/* 1. NOTIFIKASI TOAST */}
      <div style={toastStyle}>
        {notification.type === "success" ? (
          <CheckCircle size={20} color="#22c55e" />
        ) : (
          <XCircle size={20} color="#ef4444" />
        )}
        <div>
          <span
            style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b" }}
          >
            {notification.message}
          </span>
        </div>
      </div>

      {/* 2. MODAL KONFIRMASI HAPUS (CUSTOM) */}
      <div style={modalOverlayStyle}>
        <div style={modalContentStyle}>
          <div
            style={{
              width: 60,
              height: 60,
              background: "#FEF2F2",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px auto",
            }}
          >
            <Trash2 size={30} color="#EF4444" />
          </div>
          <h3
            style={{
              margin: "0 0 10px 0",
              color: "#1E293B",
              fontSize: "18px",
              fontWeight: "700",
            }}
          >
            Hapus Mata Pelajaran?
          </h3>
          <p
            style={{
              margin: "0 0 25px 0",
              color: "#64748B",
              fontSize: "14px",
              lineHeight: "1.5",
            }}
          >
            Anda akan menghapus <strong>"{deleteModal.nama}"</strong>. <br />
            Tindakan ini tidak dapat dibatalkan.
          </p>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={cancelHapus}
              style={{
                flex: 1,
                padding: "12px",
                borderRadius: "10px",
                border: "1px solid #E2E8F0",
                background: "white",
                color: "#475569",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Batal
            </button>
            <button
              onClick={confirmHapus}
              style={{
                flex: 1,
                padding: "12px",
                borderRadius: "10px",
                border: "none",
                background: "#EF4444",
                color: "white",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow: "0 4px 6px -1px rgba(239, 68, 68, 0.3)",
              }}
            >
              Ya, Hapus
            </button>
          </div>
        </div>
      </div>

      <Link
        to="/"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          textDecoration: "none",
          color: "#64748b",
          marginBottom: "20px",
        }}
      >
        <ArrowLeft size={18} /> Kembali
      </Link>

      <div
        style={{
          background: "#dbeafe",
          color: "#1e40af",
          padding: "10px 15px",
          borderRadius: "8px",
          marginBottom: "20px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          fontSize: "13px",
        }}
      >
        <ShieldCheck size={16} /> <strong>Admin Mode</strong>
      </div>

      <div
        style={{
          background: "white",
          padding: "25px",
          borderRadius: "12px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            marginTop: 0,
            color: "#1e293b",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Book color="#2563eb" /> Kelola Mata Pelajaran
        </h2>

        <form onSubmit={handleSimpan}>
          <label
            style={{
              display: "block",
              marginBottom: 5,
              fontWeight: "bold",
              fontSize: 12,
              color: "#64748b",
            }}
          >
            NAMA MAPEL
          </label>
          <input
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #cbd5e1",
              boxSizing: "border-box",
              marginBottom: "15px",
              outline: "none",
            }}
            placeholder="Contoh: Sejarah Kebudayaan Islam"
            value={formData.nama_mapel}
            onChange={(e) => setFormData({ nama_mapel: e.target.value })}
          />
          <button
            type="submit"
            style={{
              background: isEditing ? "#f59e0b" : "#2563eb",
              color: "white",
              padding: "12px",
              borderRadius: "8px",
              border: "none",
              width: "100%",
              fontWeight: "bold",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {isEditing ? <Save size={18} /> : <Plus size={18} />}
            {isEditing ? "Simpan Perubahan" : "Tambah Mapel"}
          </button>
          {isEditing && (
            <button
              type="button"
              onClick={() => {
                setIsEditing(false);
                setFormData({ nama_mapel: "" });
              }}
              style={{
                background: "#94a3b8",
                color: "white",
                padding: "8px",
                borderRadius: "8px",
                border: "none",
                width: "100%",
                fontWeight: "bold",
                cursor: "pointer",
                marginTop: "10px",
              }}
            >
              Batal
            </button>
          )}
        </form>
      </div>

      <h3 style={{ color: "#334155" }}>Daftar Mapel ({mapelList.length})</h3>
      <div
        style={{
          borderRadius: 12,
          overflow: "hidden",
          border: "1px solid #e2e8f0",
        }}
      >
        {mapelList.length === 0 && (
          <div style={{ padding: 20, textAlign: "center", color: "#94a3b8" }}>
            Belum ada data mapel.
          </div>
        )}

        {mapelList.map((item) => (
          <div
            key={item.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px",
              borderBottom: "1px solid #f1f5f9",
              background: "white",
            }}
          >
            <div style={{ fontWeight: "bold", color: "#334155" }}>
              {item.nama_mapel}
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                onClick={() => handleEdit(item)}
                style={{
                  border: "none",
                  background: "none",
                  color: "#f59e0b",
                  cursor: "pointer",
                }}
              >
                <Edit3 size={18} />
              </button>
              {/* TOMBOL HAPUS SEKARANG MEMANGGIL FUNGSI BARU */}
              <button
                onClick={() => clickHapus(item)}
                style={{
                  border: "none",
                  background: "none",
                  color: "#ef4444",
                  cursor: "pointer",
                }}
              >
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
